// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"a98964361d5900997aaf1d68dcee93884439e7f5"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/storefront/a98964361d5900997aaf1d68dcee93884439e7f5";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

import { filterSentrySpan } from '@utils/sentryFilters';

const envVars = getConfig().publicRuntimeConfig;

Sentry.init({
  dsn: envVars.SENTRY_DSN || '',
  release: envVars.SENTRY_RELEASE || '',
  tracesSampleRate: 0.05,
  debug: false,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['storefront'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  beforeSendSpan: filterSentrySpan,
});
